import { $authHost } from ".."

export const getFactoriesAllAPI = async () => {
    const {data} = await $authHost.get(`api/factories/get_factories_all`)
    return data
}